import i18n from 'i18n/config';
import { CustomAsyncSelectOption } from 'modules/_shared/components/CustomAsyncSelect/types/CustomAsyncSelectOption';

export const ownNumerationOption: CustomAsyncSelectOption = {
  value: 'own_numeration',
  label: i18n.t('NumerateFromStart'),
};
